<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard>
        <CCardHeader>
          <strong>Υποκατηγορία:</strong> {{ title }}
        </CCardHeader>
        <CCardBody>
          <CForm>
            <template slot="header">
              Edit Subcategory id:  {{ $route.params.id }}
            </template>
            <CModal
              class="modalAlert"
              :show.sync="alertIsShown"
              :centered="true"
              size="lg"
            >
              <CAlert
                closeButton
                :show.sync="alertIsShown"
                color="primary"
                fade
              >
                {{ message }}
              </CAlert>
            </CModal>
              <CInput type="text" addLabelClasses="requiredLabel" label="Όνομα" id="company" placeholder="Όνομα" v-model="name" horizontal></CInput>
              <label class="requiredLabel">Πρότυπο ISO</label>
              <multiselect 
                v-model="iso"
                id="iso"
                :options="isoOptions" 
                label="label" 
                track-by="label"
                class="mb-3"
              ></multiselect>
              <CCol tag="label" sm="3" class="requiredLabel col-form-label p-0 mb-4">
                Ενεργό
              </CCol>
              <CSwitch :checked.sync="active" shape="pill" color="success" class="pt-2" v-model="active" /><br>
            <CButton color="primary" @click="updateSubcategory()">Αποθήκευση</CButton>
            <CButton color="primary" @click="goBack">Πίσω</CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'EditSubcategory',
  props: {
    caption: {
      type: String,
      default: 'Subcategory id'
    },
  },
  components: {
    Multiselect,
  },
  data: () => {
    return {
        title: '',
        name: '',
        iso: '',
        isoOptions: [],
        active: true,
        showMessage: false,
        message: '',
        alertIsShown: false,
        dismissSecs: 7,
        dismissCountDown: 0,
        showDismissibleAlert: false
    }
  },
  computed: {
    alertModal: {
      get() {
        return this.dismissCountDown > 0;
      },
      set() {
        this.dismissCountDown = 0;
      }
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/services'})
    },
    updateSubcategory() {
        let self = this;
        let service = self.iso.value;
        axios.post('/api/servicesubcategories/' + self.$route.params.id + '?token=' + localStorage.getItem("api_token"),
        {
            _method: 'PUT',
            name: self.name,
            service: service,
            active: self.active,
        })
        .then(function (response) {
            self.message = 'Επιτυχής επεξεργασία υποκατηγορίας.';
            self.showAlert();
        }).catch(function (error) {
            if(error.response.data.message == 'The given data was invalid.'){
              self.message = '';
              for (let key in error.response.data.errors) {
                if (error.response.data.errors.hasOwnProperty(key)) {
                  self.message += error.response.data.errors[key][0] + '  ';
                }
              }
              self.showAlert();
            }else{
              console.log(error.response.data.message);
              console.log(error);
              self.$router.push({ path: '/login' }); 
            }
        });
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
  },
  mounted: function(){
    let self = this;
    axios.get('/api/servicesubcategories/' + self.$route.params.id + '/edit?token=' + localStorage.getItem("api_token"))
    .then(function (response) {
        const ser_items = Object.entries(response.data.servicesubcategory).map(([key, value]) => {return {key: key, value: value}});
        const keys = ["name"];
        self.items = ser_items.filter((t) => keys.includes(t.key));
        self.title = self.items.find((t) => t.key == "name").value;

        self.name = response.data.servicesubcategory.name;
        self.active = response.data.servicesubcategory.active == 1 ? true : false ;

        self.isoOptions = response.data.services.map((item) => {
          return {
            value: item.id,
            label: item.name
          }
        });

        self.iso = {
          value: response.data.servicesubcategory.service.id,
          label: response.data.servicesubcategory.service.name,
        };
    }).catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
    });
  }
}
</script>